/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OfferProduct } from './OfferProduct';
import {
    OfferProductFromJSON,
    OfferProductFromJSONTyped,
    OfferProductToJSON,
    OfferProductToJSONTyped,
} from './OfferProduct';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';
import type { PaymentStrategyEnum } from './PaymentStrategyEnum';
import {
    PaymentStrategyEnumFromJSON,
    PaymentStrategyEnumFromJSONTyped,
    PaymentStrategyEnumToJSON,
    PaymentStrategyEnumToJSONTyped,
} from './PaymentStrategyEnum';
import type { Customer } from './Customer';
import {
    CustomerFromJSON,
    CustomerFromJSONTyped,
    CustomerToJSON,
    CustomerToJSONTyped,
} from './Customer';
import type { OfferStateEnum } from './OfferStateEnum';
import {
    OfferStateEnumFromJSON,
    OfferStateEnumFromJSONTyped,
    OfferStateEnumToJSON,
    OfferStateEnumToJSONTyped,
} from './OfferStateEnum';
import type { DiscountTypeEnum } from './DiscountTypeEnum';
import {
    DiscountTypeEnumFromJSON,
    DiscountTypeEnumFromJSONTyped,
    DiscountTypeEnumToJSON,
    DiscountTypeEnumToJSONTyped,
} from './DiscountTypeEnum';
import type { PriceList } from './PriceList';
import {
    PriceListFromJSON,
    PriceListFromJSONTyped,
    PriceListToJSON,
    PriceListToJSONTyped,
} from './PriceList';

/**
 * 
 * @export
 * @interface Offer
 */
export interface Offer {
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    id: number;
    /**
     * 
     * @type {Customer}
     * @memberof Offer
     */
    customer: Customer;
    /**
     * 
     * @type {User}
     * @memberof Offer
     */
    createdBy?: User | null;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    approvedAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    validTo: Date;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    contractValidFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    stateFrom?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof Offer
     */
    terminationOn?: Date | null;
    /**
     * 
     * @type {Array<OfferProduct>}
     * @memberof Offer
     */
    products: Array<OfferProduct>;
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    discount: number;
    /**
     * 
     * @type {DiscountTypeEnum}
     * @memberof Offer
     */
    discountType: DiscountTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    total: number;
    /**
     * 
     * @type {OfferStateEnum}
     * @memberof Offer
     */
    state: OfferStateEnum;
    /**
     * 
     * @type {PriceList}
     * @memberof Offer
     */
    priceList: PriceList;
    /**
     * 
     * @type {PaymentStrategyEnum}
     * @memberof Offer
     */
    paymentStrategy: PaymentStrategyEnum;
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    paymentInterval: number;
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof Offer
     */
    contractNumber: string | null;
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    firstPaymentValueTotal?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Offer
     */
    prevOfferId?: number | null;
}



/**
 * Check if a given object implements the Offer interface.
 */
export function instanceOfOffer(value: object): value is Offer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('customer' in value) || value['customer'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('approvedAt' in value) || value['approvedAt'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    if (!('contractValidFrom' in value) || value['contractValidFrom'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('priceList' in value) || value['priceList'] === undefined) return false;
    if (!('paymentStrategy' in value) || value['paymentStrategy'] === undefined) return false;
    if (!('paymentInterval' in value) || value['paymentInterval'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined) return false;
    return true;
}

export function OfferFromJSON(json: any): Offer {
    return OfferFromJSONTyped(json, false);
}

export function OfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): Offer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'customer': CustomerFromJSON(json['customer']),
        'createdBy': json['createdBy'] == null ? undefined : UserFromJSON(json['createdBy']),
        'created': (new Date(json['created'])),
        'approvedAt': (json['approvedAt'] == null ? null : new Date(json['approvedAt'])),
        'validTo': (new Date(json['validTo'])),
        'contractValidFrom': (new Date(json['contractValidFrom'])),
        'stateFrom': json['stateFrom'] == null ? undefined : (new Date(json['stateFrom'])),
        'terminationOn': json['terminationOn'] == null ? undefined : (new Date(json['terminationOn'])),
        'products': ((json['products'] as Array<any>).map(OfferProductFromJSON)),
        'discount': json['discount'],
        'discountType': DiscountTypeEnumFromJSON(json['discountType']),
        'total': json['total'],
        'state': OfferStateEnumFromJSON(json['state']),
        'priceList': PriceListFromJSON(json['priceList']),
        'paymentStrategy': PaymentStrategyEnumFromJSON(json['paymentStrategy']),
        'paymentInterval': json['paymentInterval'],
        'text': json['text'],
        'contractNumber': json['contractNumber'],
        'firstPaymentValueTotal': json['firstPaymentValueTotal'] == null ? undefined : json['firstPaymentValueTotal'],
        'prevOfferId': json['prevOfferId'] == null ? undefined : json['prevOfferId'],
    };
}

export function OfferToJSON(json: any): Offer {
    return OfferToJSONTyped(json, false);
}

export function OfferToJSONTyped(value?: Offer | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customer': CustomerToJSON(value['customer']),
        'createdBy': UserToJSON(value['createdBy']),
        'created': ((value['created']).toISOString()),
        'approvedAt': ((value['approvedAt'] as any).toISOString()),
        'validTo': ((value['validTo']).toISOString()),
        'contractValidFrom': ((value['contractValidFrom']).toISOString()),
        'stateFrom': value['stateFrom'] === null ? null : ((value['stateFrom'] as any)?.toISOString()),
        'terminationOn': value['terminationOn'] === null ? null : ((value['terminationOn'] as any)?.toISOString()),
        'products': ((value['products'] as Array<any>).map(OfferProductToJSON)),
        'discount': value['discount'],
        'discountType': DiscountTypeEnumToJSON(value['discountType']),
        'total': value['total'],
        'state': OfferStateEnumToJSON(value['state']),
        'priceList': PriceListToJSON(value['priceList']),
        'paymentStrategy': PaymentStrategyEnumToJSON(value['paymentStrategy']),
        'paymentInterval': value['paymentInterval'],
        'text': value['text'],
        'contractNumber': value['contractNumber'],
        'firstPaymentValueTotal': value['firstPaymentValueTotal'],
        'prevOfferId': value['prevOfferId'],
    };
}

